import { useContext, useEffect } from 'react';
import {
  CalendarContext,
  setSchedules,
  clearSlots,
} from 'presentations/views/components/atoms/Calendar/reducer/CalendarContext';
import { EventListItem, Schedule } from '../../atoms/Calendar/reducer';

interface Props {
  schedules: Schedule[] | null;
  isLoading?: boolean;
  onClickBookingSlot?: (event: EventListItem) => void;
}

export const useBookingCalendar = (props: Props) => {
  const { dispatch } = useContext(CalendarContext);

  useEffect(() => {
    if (props.isLoading) {
      dispatch(setSchedules(null));
      return;
    }
    dispatch(setSchedules(props.schedules));
  }, [props.schedules, props.isLoading]);

  const onClickBookingSlot = (event: EventListItem) => {
    props.onClickBookingSlot && props.onClickBookingSlot(event);
  };

  const onClearSelectedDates = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    dispatch(clearSlots());
  };

  return {
    actions: {
      onClickBookingSlot,
      onClearSelectedDates,
    },
  };
};
